'use client'

import { SelectionCard } from '@graftcode/design-system'

import type { CardData } from '../../../types'
import { NoResultsState } from '../../NoResultsState'

import styles from './RootView.module.scss'

type RootViewListItem = CardData['list'][number]

interface RootViewListProps {
  searchQuery: string
  filteredList: RootViewListItem[]
}

export function RootViewList({ searchQuery, filteredList }: RootViewListProps) {
  const hasSearch = searchQuery.trim().length > 0
  const isEmpty = filteredList.length === 0
  const showNoResults = hasSearch && isEmpty

  return (
    <div className={styles.listContainer}>
      {showNoResults ? (
        <NoResultsState />
      ) : (
        filteredList.map((card) => (
          <SelectionCard key={card.id} {...card}>
            {card.children}
          </SelectionCard>
        ))
      )}
    </div>
  )
}
